import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';

import { ItemUnidadeRoutingModule } from './item-unidade-routing.module';
import { ItemUnidadeComponent } from './item-unidade.component';
import { ItemUnidadeFormComponent} from './form';

@NgModule({
    imports: [
        SharedModule,
        ItemUnidadeRoutingModule
    ],
    declarations: [
        ItemUnidadeComponent,
        ItemUnidadeFormComponent
    ]
})
export class ItemUnidadeModule { }
